import { useEffect, useState } from 'react';

const matches = (query: string): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false;

/**
 * Whether a CSS media query matches, following it as the window resizes. False where there is no `matchMedia`
 * (jsdom), so a test gets the wide layout unless it stubs one.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matched, setMatched] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(query);
    const follow = () => setMatched(media.matches);
    follow();
    media.addEventListener('change', follow);
    return () => media.removeEventListener('change', follow);
  }, [query]);
  return matched;
};
